<div class="topbar">
  <div class="topbar__menuIcons" (click)="emitToggleFullScreenSidebar()">
    @if (sidebarOpen) {
      <mat-icon class="material-icons-round">menu_open </mat-icon>
    }
    @if (!sidebarOpen) {
      <mat-icon class="menu-icon material-icons-round">menu</mat-icon>
    }
  </div>
  <app-omnisearch></app-omnisearch>

  @if (filteredNotifications$ | async; as notifs) {
    <mat-icon
      class="bell"
      matBadgeSize="small"
      matBadgeColor="warn"
      data-test-id="topbar-notifications-icon"
      aria-hidden="false"
      [matBadge]="notifs.length"
      [matBadgeHidden]="!notifs.length"
      (click)="openNotifications()"
    >
      notifications</mat-icon
    >
  }
</div>
